<template>
  <div>
    <v-collapse-wrapper :active="true">
      <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
           v-collapse-toggle>
        <h3>{{$t('form.lot.protocols')}}</h3>
      </div>

      <export-protocol ref="exportDialog" :commission="lot.commission" v-if="lot.commission && lot.commission.length" @save="onReadyProtocol"></export-protocol>

      <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
        <v-collapse-group class="a-ui-tab">
          <div class="a-ui-tab__block" v-for="(protocol, idx) in lot.protocols">
            <v-collapse-wrapper :active="true">
              <div class="a-ui-tab__control-panel">
                <div class="a-ui-tab__control a-width-100-percent" v-collapse-toggle>
                  <div class="a-ui-tab__arrow"></div>
                  <div class="a-ui-tab__number-block">{{idx + 1}}</div>
                  <div class="a-ui-tab__title">
                    {{$t(protocol.type.label)}}
                  </div>
                </div>

                <div class="a-ui-tab__control a-width-100-percent u-margin-b-13"
                     v-if="protocol.permissions.CAN_DOWNLOAD_PROTOCOL">
                  <button class="gui-btn gui-btn--red gui-btn--w-260" type="button" @click="onExportProtocolClick(protocol)">{{$t('buttons.create-protocol')}}</button>
                </div>

                <div class="a-ui-tab__control a-width-100-percent u-margin-b-13"
                     v-if="protocol.type.ACCEPT && lot.permissions.CAN_BACK_TO_RETEND">
                    <button class="gui-btn gui-btn--white-border" @click.prevent="onReturnToRetendClick">Вернуться на этап переторжек</button>
                </div>

                <div class="a-ui-tab__content-block a-width-100-percent"
                     style="background-color: #EEEEEE"
                     v-if="protocol.type.ACCEPT && protocol.returnReason">
                  <div class="a-ui-tab__content u-padding-top-12px">
                    <div class="a-container-form">
                      <div class="a-label a-label--w-280 u-red-color">
                        Причина возврата:
                        <v-popover class="d-inline-block u-margin-right-20" placement="right" v-if="protocol.returnReasons">
                          <img src="@/assets/img/static/info.svg">

                          <template slot="popover">
                            <span class="a-formatted-text text-left font-weight-normal">
                              <div v-for="item in protocol.returnReasons">
                                <date-time tag="span" :value="item.time"></date-time>
                                <span class="u-margin-left-20">{{item.reason}}</span>
                              </div>
                            </span>
                          </template>
                        </v-popover>
                      </div>
                      <div class="a-label a-label--auto u-red-color">{{protocol.returnReason}}</div>
                    </div>
                    <div class="a-ui-tab__file-flex-block">
                      <div class="a-ui-tab__file-item-left"></div>
                      <div class="a-ui-tab__file-item-right u-margin-right-20">
                        <button class="gui-btn gui-btn--red gui-btn--w-160"
                                @click.prevent="onChangeReturnToRetendClick"
                                v-if="lot.permissions.CAN_CHANGE_BACK_TO_RETEND">Редактировать</button>
                      </div>
                    </div>
                  </div>
                </div>
               </div>
              <div class="a-ui-tab__content-block" v-collapse-content>
                <draft-protocols :lot="lot" :protocol="protocol"></draft-protocols>

                <div class="a-ui-tab__content">
                  <div class="a-label a-label--auto u-padding-bottom-12">Итоговый протокол голосования членов комиссии по этапу</div>

                  <div class="a-ui-tab__file-flex-block" v-for="file in protocol.files">
                    <div class="a-ui-tab__file-item-left">
                      <div class="a-ui-tab__file-block-number" v-if="file.hasFile">
                        {{file.version}}
                      </div>

                      <file-link :name="file.name"
                                 :link="externalLink(file.uid)"
                                 :signed="file.hasSign"
                                 @onsigncheck="onFileSignCheckClick(file.version)"
                                 v-if="file.hasFile">
                        <div class="input-file__actual-block">
                          <div class="input-file__actual-img input-file__hidden">
                            <img src="@/assets/img/static/clientarea-details.svg" alt="">
                          </div>
                          <div class="input-file__actual" v-if="file.isActual">{{$t('form.lot.actual-file-version')}}</div>
                          <div class="input-file__not-actual" v-else>{{$t('form.lot.legacy-file-version')}}</div>
                        </div>
                      </file-link>

                      <template v-if="!file.hasFile && protocol.permissions.CAN_UPLOAD_PROTOCOL">
                        <file-picker label="Прикрепить подписанный комиссией"
                                     :signing="lot.permissions.SHOULD_BE_SIGNED"
                                     :confirmation="protocol.type.ACCEPT ? $t(protocol.type.label) : undefined"
                                     @prepared="onFileReady($event, { type: protocol.type.valueOf() })">
                          <template v-slot:question>
                            Уведомление об Акцепте  будет направлено Участнику, только у которого в предложении указан статус "Акцептировано".
                            Проверьте указания Вами статуса "Акцептировано" в соответствующем  предложении соответствующего участника.
                          </template>
                        </file-picker>
                      </template>
                    </div>

                    <div class="a-ui-tab__file-item-right" v-if="file.hasFile && file.permissions.CAN_RECOVERY_PROTOCOL">
                      <button class="gui-btn gui-btn--red gui-btn--w-160" v-if="!file.isActual" type="button" @click="onRestoreFileClick(({type: protocol.type.valueOf(), version: file.version}))">{{$t('buttons.restore-file')}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </v-collapse-wrapper>
          </div>
          <div class="a-container-form"
               v-if="lot.permissions.CAN_BE_SENT_TO_1C">
            <button class="gui-btn gui-btn--red gui-btn--w-260"
                    @click.prevent="onUploadTo1CClick">{{$t('buttons.upload-to-1C')}}</button>
          </div>
          <div class="a-container-form"
               v-if="lot.permissions.CAN_BACK_TO_ACCEPT">
            <button class="gui-btn gui-btn--red gui-btn--w-260"
                    @click.prevent="onReturnToAcceptClick">
              Вернуться на этап выбора победителей
            </button>
          </div>

        </v-collapse-group>
      </div>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
      <confirmation-dialog ref="confirmation" @confirm="onConfirm" @cancel="$refs.confirmation.close()"></confirmation-dialog>

      <confirmation-dialog ref="confirmationWithReason" close-on-action>
        <template v-slot:body>
          <div class="a-container-form">
            <label class="a-label a-label--w-180">Причины возврата:</label>
            <textarea class="a-textarea a-textarea--w-max" rows="4" v-model="returnReason"/>
          </div>
        </template>
      </confirmation-dialog>
    </v-collapse-wrapper>
  </div>
</template>

<script>
  import ExportProtocol from './protocols/ExportProtocolDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import ConfirmationDialog from '@/components/common/dialogs/ConfirmationDialog'
  import Errors from '@/api/types/errors'
  import TemplateItem from "../../admin/catalogs/templates/TemplateItem";
  import DraftProtocols from "./protocols/DraftProtocols";

  export default {
    props: {
      lot: Object
    },

    data: () => ({
      protocol: undefined,
      returnReason: undefined
    }),

    components: {
      TemplateItem,
      ConfirmationDialog,
      ExportProtocol,
      SignatureDetailsDialog,
      DraftProtocols
    },

    methods: {
      async onFileReady(file, { type }) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addFileToProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              file: file.file,
              sign: file.sign
            });
          }
          catch(e) {
            console.error('failed attaching file to protocol', e);
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.public-lot.attaching-file-to-protocol.bad-signature'
            }, 'errors.public-lot.attaching-file-to-protocol.unknown');
          }
        })
      },


      async onRestoreFileClick({type, version}) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('restoreFileInProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              version: version
            });
          }
          catch(e) {
            console.error('failed restoring file in protocol', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onExportProtocolClick({ type }) {
        const doExportProtocol = (alertMessage) => {
          this.protocol = type.valueOf();
          this.$refs.exportDialog.open(alertMessage);
        };

        // if (type.RETEND) {
        //   this.askConfirmation({
        //     title: 'Формирование протокола переторжки',
        //     body: 'При формировании протокола переторжки дальнейшие торги с участниками будут невозможны, сформировать протокол переторжки?',
        //     onConfirm: doExportProtocol
        //   })
        // }
        //else
        if (type.ACCEPT) {
          const hasAcceptedBid = _.some(this.lot.requests, request => {
            return _.some(request.bids, bid => bid.state.ACCEPTED);
          });

          this.askConfirmation({
            title: 'Формирование протокола акцепта',
            body: 'Этап предоставления разбивки предложений завершится, уверены?\n',

            onConfirm: () => {
              const alertMessage = hasAcceptedBid? undefined :
                'Внимание! Не одно предложение Предложение на акцептировано, Протокол  сформируется без указания победителя, а Победитель не получит автоматического уведомления об акцепте своего предложения'
              doExportProtocol(alertMessage);
            }
          })
        }
        else {
          doExportProtocol();
        }
      },

      async onReadyProtocol(report) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('downloadReport', {
              lotId: this.lot.id,
              protocolType: this.protocol,
              report: report
            });
          }
          catch(e) {
            console.error('failed download protocol', e);
            this.globalErrorHandler(e);
          }

          this.$refs.exportDialog.close();
        })
      },

      async onFileSignCheckClick(version) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkProtocolFileSignature', {
              lotId: this.lot.id,
              type: this.protocol.type,
              version: version
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking file signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onUploadTo1CClick(){
        this.$refs.confirmation.open({
          title: 'dialogs.upload-to-1c.title',
          text: 'dialogs.upload-to-1c.body',
          warn: 'dialogs.upload-to-1c.warning'
        });
      },

      async onConfirm() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('uploadTo1C', {
              lotId: this.lot.id
            });
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to upload tender to 1C', e);
            this.globalErrorHandler(e);
          }
        })
      },

      onReturnToRetendClick() {
        this.returnReason = '';
        this.$refs.confirmationWithReason.open({
          title: 'Возврат на этап переторжек',
          onConfirm: () => {
            this.runBlockerAction(async () => {
              try {
                await this.$store.dispatch('backToRetendFromAccept', {
                  lotId: this.lot.id,
                  reason: this.returnReason
                });
              }
              catch(e) {
                console.error('unable to back to retend step', e);
                this.globalErrorHandler(e);
              }
            })
          }
        })
      },

      onReturnToAcceptClick() {
        this.returnReason = '';
        this.$refs.confirmationWithReason.open({
          title: 'Возврат на этап выбора победителей',
          onConfirm: () => {
            this.runBlockerAction(async () => {
              try {
                await this.$store.dispatch('backToAcceptFromResult', {
                  lotId: this.lot.id,
                  reason: this.returnReason
                });
              }
              catch(e) {
                console.error('unable to back to accept step', e);
                this.globalErrorHandler(e);
              }
            })
          }
        })
      },

      onChangeReturnToRetendClick() {
        this.returnReason = '';
        this.$refs.confirmationWithReason.open({
          title: 'Изменение возврата на этап переторжек',
          onConfirm: () => {
            this.runBlockerAction(async () => {
              try {
                  await this.$store.dispatch('changeBackToRetendFromAccept', {
                  lotId: this.lot.id,
                  reason: this.returnReason
                });
              }
              catch(e) {
                console.error('unable to change back to retend step', e);
                this.globalErrorHandler(e);
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
